<template>
  <div style="min-height: 92vh">
    <div>
      <h3>Agencias</h3>
      <uv-data-table :config="config" :data="hoteles" :pageRows="15" @buttonClick="dtButtonClick"></uv-data-table>
    </div>
    <modal v-model="showURL" :showFooter="false" title="URL Agencias">
      <div class="mb-4 text-body-1">
        Selecciona una subcategoría de tarifa para generar la URL:
      </div>
      <v-alert v-if="subcategoriasVigentes.length == 0" type="warning" text dense>
        Este afiliado no tiene tarifas vigentes.
      </v-alert>
      <v-autocomplete :items="subcategoriasVigentes" v-model="subcategoriaSeleccionada" label="Tarifa" outlined dense
        clearable></v-autocomplete>

      <v-slide-y-transition>
        <v-alert v-if="subcategoriaSeleccionada" outlined color="green" class="mt-2">
          <div class="text-h6 mb-2">
            URL de reserva web para <b>{{ editData.Nombre }}</b>
          </div>
          <div class="pa-3 mb-4 rounded"
            style="background-color: rgba(76, 175, 80, 0.1); word-break: break-all; font-family: monospace; font-size: 1.1em;">
            {{ fullUrl }}
          </div>
          <v-btn @click="copy()" color="green" dark depressed>
            <v-icon left>mdi-content-copy</v-icon>
            Copiar al portapapeles
          </v-btn>
          <v-btn @click="generarQR()" color="green" outlined depressed class="ml-2">
            <v-icon left>mdi-qrcode</v-icon>
            Generar QR
          </v-btn>
          <div v-if="qrDataUrl" class="mt-4 text-center">
            <img :src="qrDataUrl" alt="QR de reserva" style="max-width: 100%; width: 256px;" />
            <div class="mt-2">
              <v-btn @click="descargarQR()" color="green" dark depressed small>
                <v-icon left>mdi-download</v-icon>
                Descargar QR
              </v-btn>
            </div>
          </div>
        </v-alert>
        <v-alert v-else type="info" text class="mt-2">
          La URL se generará una vez que selecciones la tarifa.
        </v-alert>
      </v-slide-y-transition>
    </modal>
    <modal v-model="showModal" :showFooter="false" title="Agregar Agencia">
      <addform :key="formKey" @toggle="toggleModal" @successData="successData"></addform>
    </modal>
    <modal v-model="showModalEdit" :showFooter="false" title="Editar Agencia">
      <editform :key="formKeyEdit" :editData="editData" @toggle="showModalEdit = false" @successData="successDataEdit">
      </editform>
    </modal>
  </div>
</template>

<style></style>

<script>
import { mapGetters, mapActions } from 'vuex';
import modal from "../MainComponents/modal.vue";
import addform from "./addMayoristaForm.vue";
import editform from "./editMayoristaForm.vue";
import uvDataTable from "../MainComponents/DataTable.vue";
import QRCode from "qrcode";
import moment from "moment";
import TarifasClass from "../../clases/Tarifa";

export default {
  name: "MayoristasCRUD",
  components: {
    modal,
    addform,
    editform,
    uvDataTable,
  },
  props: [],
  data() {
    return {
      urlBase: "system.pargolfsolutions.com",
      subcategoriaSeleccionada: null,
      qrDataUrl: null,
      temporadas: [],
      tarifarios: [],
      editData: {},
      showURL: false,
      formKeyEdit: 1,
      showModalEdit: false,
      showModal: false,
      formKey: 0,
      hoteles: [],
      config: {
        selectableRow: true,
        allowExport: true,
        rawText: "Agencia",
        orderByCol: { Field: "", Type: "Asc" },
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addHotel",
            require: false,
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editHotel",
            require: true,
          },
          {
            text: "URL Reserva Web",
            icon: "lni lni-link",
            buttonId: "webUrl",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteHotel",
            require: true,
          },
        ],
        fields: [
          {
            title: "Nombre",
            dataName: "Nombre",
            text: "Nombre",
            value: "Nombre",
          },
          {
            text: "Codigo",
            value: "Codigo",
          },
        ],
      },
    };
  },
  methods: {
    ...mapActions('TarifasStore', ['getSubcategoria']),
    async getTemporadas() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "RVA/Tarifas/Golf/Temporadas"
      );
      if (!data.exists()) return;
      this.temporadas = Object.entries(data.val()).map(([id, t]) => ({ id, ...t }));
    },
    async getTarifarios() {
      this.tarifarios = await TarifasClass.getMixTarifasCombo("Golf");
    },
    async generarQR() {
      try {
        // el protocolo es necesario para que los lectores QR lo abran como enlace
        this.qrDataUrl = await QRCode.toDataURL(`https://${this.fullUrl}`, {
          width: 512,
          margin: 2,
          errorCorrectionLevel: "M",
        });
      } catch (e) {
        this.$toast.error(" ", "Error generando el QR");
      }
    },
    descargarQR() {
      const a = document.createElement("a");
      a.href = this.qrDataUrl;
      a.download = `QR-${this.editData.Codigo}-${this.subcategoriaSeleccionada.replace("/", "-")}.png`;
      a.click();
    },
    copy() {
      let url =
        this.urlBase +
        "/" +
        this.$store.getters.getFirebaseApp.tenant +
        "/affiliates/" +
        this.editData.Codigo +
        "/golf/booking/GUESTPAID";

      navigator.clipboard.writeText(url).then(
        () => {
          this.$toast.success(" ", "Copiado al portapapeles");
        },
        function () {
          this.$toast.error(" ", "Error copiando");
        }
      );
    },
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "addHotel") {
        this.toggleModal(true);
      }
      if (buttonId == "deleteHotel") {
        let hotel = this.getHotelById(idSelected[0]);
        this.deletHotel(idSelected[0], hotel.Codigo);
      }
      if (buttonId == "editHotel") {
        this.formKeyEdit++;
        this.showModalEdit = true;
        this.editData = this.getHotelById(idSelected[0]);
      }
      if (buttonId == "webUrl") {
        this.editData = this.getHotelById(idSelected[0]);
        this.subcategoriaSeleccionada = null;
        this.showURL = true;
      }
    },
    getHotelById(code) {
      let itemIndex = this.$_.findIndex(this.hoteles, { id: code });
      if (itemIndex >= 0) {
        return this.hoteles[itemIndex];
      }

      return false;
    },
    async getHoteles() {
      //obtiene el listado de hoteles afiliados
      this.hoteles = [];
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "RVA/Mayoristas/Coleccion"
        );
      this.hoteles = [];
      let arrayHoteles = Object.entries(snapshot.val());
      arrayHoteles.forEach((element) => {
        this.hoteles.push({ id: element[0], ...element[1] });
      });
    },
    deletHotel(idHotel, hCode) {
      this.$swal({
        title: "¿Deseas eliminar esta Agencia?",
        text: "Se eliminara permanentemente",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          let data = { hId: idHotel, hCode: hCode };
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Mayoristas-eliminarMayorista", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Agencia eliminada",
              "La agencia se eliminó correctamente",
              "success"
            );
            this.$emit("changeIndex");
          } else {
            this.$swal("Error al eliminar", result.value.data.error, "error");
          }
        }
      });
    },
    successData(data) {
      let duration =
        data.duracion.horas.toString().padStart(2, "0") +
        ":" +
        data.duracion.minutos.toString().padStart(2, "0") +
        ":00";
      let dataHotel = {
        hotelCode: data.codigo,
        Nombre: data.nombre,
        AvaiColor: data.defaultColor ? undefined : data.AvaiColor,
        ActiTrans: data.transportacionActivada,
        Transportacion: {
          DuracionViaje: duration,
          ExtraParams: { epHotelId: data.epHotelId },
          TransportacionActivada: data.transportacionActivada,
          PrecioRT: parseFloat(data.PrecioRT),
          PrecioOWGH: parseFloat(data.PrecioOWGH),
          PrecioOWHG: parseFloat(data.PrecioOWHG),
          Moneda: "USD",
        },

        URLAdmin: data.ruta,
      };
      this.$pgsHelper.log(dataHotel);
      this.saveHotel(dataHotel);
    },
    successDataEdit(data) {
      data.Id = data.id;
      this.$pgsHelper.log(data);
      this.editHotel(data);
    },
    editHotel(data) {
      this.$pgsHelper.log(data);
      if (data.defaultColor) {
        delete data.AvaiColor;
      }
      let datos = {
        Id: data.id,
        Nombre: data.nombre,
        AvaiColor: data.defaultColor ? null : data.AvaiColor,
      };
      this.$swal({
        title: "¿Deseas editar la agencia?",
        text: "La agencia se editará con los datos especificados",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Editar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Mayoristas-editarMayorista", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Agencia Editada",
              "La agencia se editó correctamente",
              "success"
            );
            this.formKeyEdit++;
            this.showModalEdit = false;
            this.getHoteles();
          } else {
            this.$swal(
              "Error al guardar los datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    saveHotel(data) {
      this.$swal({
        title: "Deseas guardar esta agencia?",
        text: "La agencia se guardará con los datos especificados",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Mayoristas-crearMayorista", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Agencia Guardada",
              "La agencia se almacenó correctamente",
              "success"
            );

            this.showModal = false;
            this.getHoteles();
            this.formKey++;
          } else {
            this.$swal(
              "Error al guardar los datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    toggleModal(open) {
      this.showModal = open;
    },
  },
  computed: {
    ...mapGetters('TarifasStore', ['getSubcategorias']),
    // combinaciones tarifario/subcategoria con tarifa vigente hoy y con acceso para el afiliado seleccionado
    subcategoriasVigentes() {
      const hoy = moment().format("YYYY-MM-DD");
      const temporadasVigentes = this.temporadas
        .filter(
          (t) =>
            moment(t.FechaInicio).format("YYYY-MM-DD") <= hoy &&
            moment(t.FechaTermino).format("YYYY-MM-DD") >= hoy
        )
        .map((t) => t.id);
      const tarifas = this.$store.getters["dataLists/getRVATarifas"] || [];
      const pares = new Map();
      tarifas.forEach((tarifa) => {
        const accesos = Array.isArray(tarifa.Accesos) ? tarifa.Accesos : [];
        if (
          tarifa.Departamento == "Golf" &&
          tarifa.Tarifario &&
          temporadasVigentes.includes(tarifa.Temporada) &&
          (accesos.includes(this.editData.id) || accesos.includes("Global"))
        ) {
          (tarifa.Subcategoria || []).forEach((subId) => {
            pares.set(`${tarifa.Tarifario}/${subId}`, { tarifarioId: tarifa.Tarifario, subId });
          });
        }
      });
      const items = [];
      pares.forEach(({ tarifarioId, subId }, value) => {
        const sub = this.getSubcategorias.find((s) => s.id === subId);
        if (!sub) return;
        const repetida = [...pares.values()].filter((p) => p.subId === subId).length > 1;
        const tarifario = this.tarifarios.find((t) => t.Id === tarifarioId);
        items.push({
          value,
          text: repetida && tarifario ? `${sub.text} (${tarifario.Nombre})` : sub.text,
        });
      });
      return items;
    },
    fullUrl() {
      return `${this.urlBase}/${this.$store.getters.getFirebaseApp.tenant}/affiliates/${this.editData.Codigo}/golf/booking/GUESTPAID/${this.subcategoriaSeleccionada}`;
    },
  },
  watch: {
    fullUrl() {
      this.qrDataUrl = null;
    },
    showURL(v) {
      if (!v) this.qrDataUrl = null;
    },
  },
  mounted() { },
  created() {
    this.getHoteles();
    this.getSubcategoria("Golf");
    this.getTemporadas();
    this.getTarifarios();
  },
};
</script>
